const typegraphy = {
    fontFamily: "Gotham Rounded",
    h1: {
        fontFamily: "Gotham Rounded",
        fontSize: 45,
        fontWeight: 'bold'
    },
    h2: {
        fontFamily: "Gotham Rounded",
        fontSize: 45,
        fontWeight: 'bold'
    },
    h3: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    h4: {
        fontSize: 21,
        fontWeight: 'bold'
    },
    h5: {
        fontSize: 13,
        fontWeight: '350'
    },
    h6: {
        fontSize: 12,
        fontWeight: '350'
    },
    caption: {
        fontFamily: "Gotham Rounded",
        fontSize: 19,
        fontWeight: 'medium'
    },
    subtitle2: {
        fontFamily: "Gotham Rounded",
        fontSize: 14,
        fontWeight: 'Bold'
    },
    button: {
        fontFamily: "Gotham Rounded",
        fontSize: 18,
        fontWeight: 'bold',
        textTransform: 'none'
    },
    body2: {
        fontSize: 20,
        fontWeight: 300,
        fontStyle: "normal",
    }
}

export default typegraphy
